// Filter options for the Today surface, shared by web and mobile. Passed to
// `useTasksByFilterDocument` alongside the document returned by
// `buildTodayFilterDocument`.
//
// - `includeTaskWithAction`: include tasks that have an `action` set
//   (GoalTimeslot, LifeAreaTimeslot, etc.). Today shows timeblocked actions.
// - `excludeHiddenTodoHabits`: per-habit `hideOnTodo` flag is respected —
//   habits users opted out of Today are never shown there regardless of any
//   "hide habits" user toggle.
export const todayFilterOptions = {
  includeTaskWithAction: true,
  excludeHiddenTodoHabits: true,
} as const;
